import { gql } from '@apollo/client';

export const CREATE_SERIES = gql`
    mutation CreateSeries($input:CreateSeriesInput!) {
    createSeries(input: $input) {
        data {
            video_series {
                category_id
                created_at
                folder_id
                id
                series_order
                title
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}


`;
export const UPDATE_SERIES = gql`
  mutation UpdateSeries($input:UpdateSeriesInput) {
    updateSeries(input: $input) {
        data {
            video_series {
                category_id
                created_at
                folder_id
                id
                series_order
                title
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}


`;
export const DELETE_SERIES = gql`
  mutation DeleteSeries($series_id:UUID,$folder_id: String) {
    deleteSeries(series_id: $series_id, folder_id: $folder_id) {
        error {
            message
        }
        data {
            message
        }
    }
}

`;